export const KB_VERSIONS = [
  { id: "DEFAULT", name: "DEFAULT" },
  { id: "IT", name: "IT" },
];
